// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <p>This API is deprecated and scheduled for deactivation in the 3rd quarter of 2020.</p>
    </div>
  );
};

export default MarkdownComponent;
